import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import '@fortawesome/fontawesome-free/css/all.css'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        secondary: '#4caf50', // green
        tertiary: '#495057', // ????
        // accent: '#82B1FF',
        error: '#f55a4e', // red
        info: '#00d3ee', // light blue
        success: '#3f51b5', // indigo
        warning: '#ffa21a', // pending orange

        hrissecondary: '#3796CF', // light blue
        hrissuccess: '#4caf50', // green
        primary: '#9c27b0', // purple
      },
    },
  },
  icons: [
    {
      iconfont: 'mdi',
    }, 
    {
      iconfont: 'fa',
    },
    {
      iconfont: 'md',
    },
  ],
})
